export default __webpack_public_path__ + "media/images/payments/visa-97826d5f6381263f2ac29661a018f583.svg";